import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    statuses       : ['answered', 'processing'],
    themes         : ['База знаний', 'Обучение', 'Профиль', 'Новости и мероприятия', 'Другое'],
    request_modal  : false,
    selected_theme : null,
    selected_number: 10,
    selected_page  : 1,
    list           : [],
    search_string  : '',
    active_item    : null,
  },
  getters: {
    list           : ({list}) => list,
    last_request   : ({list=[]}) => list[list.length-1],
    themes         : ({themes}) => themes,
    request_modal  : ({request_modal}) => request_modal,
    selected_theme : ({selected_theme}) => selected_theme,
    selected_number: ({selected_number}) => selected_number,
    selected_page  : ({selected_page}) => selected_page,
    search_string  : ({search_string}) => search_string,
    active_item    : ({active_item}) => active_item,
    filtered_by_theme({list=[]}, {selected_theme}) {
      if (selected_theme && selected_theme !== 'Все темы' ) {
        return list.filter((item)=> item.theme == selected_theme);
      } else {
        return list;
      }
    },
    search_by_string: ({selected_theme, list=[], search_string}, {filtered_by_theme})=> {
      if (selected_theme) {
        return filtered_by_theme.filter((x)=> x.title&& x.title.toLowerCase().includes(search_string.toLowerCase()));
      } else {
        return list.filter((x)=> x.title&& x.title.toLowerCase().includes(search_string.toLowerCase()));
      }
    },
    paginated({search_string}, {selected_number, filtered_by_theme, selected_page, search_by_string}) {
      if (search_string) {
        return search_by_string.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else {
        return filtered_by_theme.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      }
    },
  },
  mutations: {
    SET_ACTIVE_ITEM(state, id) {
      state.active_item = id;
    },
    CLOSE_MODAL(state) {
      state.request_modal = false;
    },
    OPEN_CONTACT_MODAL(state) {
      if (!state.request_modal) {
        state.request_modal = true;
      }
    },
    SET_SELECTED_THEME(state, value) {
      state.selected_theme = value;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    SEND_QUESTION(state, question) {
      state.list.push(question.question);
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SET_QUESTIONS(state, questions) {
      if (!questions.list) {
        state.list=[];
      } else {
        state.list = questions.list;
      }
    },
    SEARCH_STRING(state, value) {
      state.search_string = value;
    },
  },
  actions: {
    show_number({commit, getters}, event) {
      const {filtered_by_theme} = getters;
      commit('CLEAR_PAGES');
      commit('SHOW_NUMBER', {array: filtered_by_theme, selected: event});
    },
    ask_question({state, commit, getters, dispatch}, question) {
      const {last_request} = getters;
      let new_question = {
        id    : last_request &&last_request.id ? last_request.id+1 : 1,
        title : question.question_text,
        status: 'processing',
        theme : question.question_theme,
        text  : 'Обрабатывается',
      };
      commit('SEND_QUESTION', {question: new_question});
      dispatch('post_feedback_questions', new_question);
      commit('CLOSE_MODAL');
    },
    async get_feedback_questions({commit}) {
      try {
        const feedback_questions = await api.feedback.get_feedback_questions();
        commit('SET_QUESTIONS', feedback_questions.data);
      } catch (err) {
        console.error(err);
      }
    },
    async post_feedback_questions({commit}, new_question) {
      try {
        await api.feedback.post_feedback_questions(new_question);
        commit('CLOSE_MODAL');
        commit('faq/questions/CLOSE_MODAL', {}, {root: true});
      } catch (err) {
        console.error(err);
      }
    },
  },
};
